'use strict';

angular.module('docketbook').
factory('formatHelper', function($timeout) {
  var root = {};

  /* Format time quantity */

  root.formatTimeQuantity = function(quantity, abbreviation) {
    // NB: quantity is always in minutes
    var formattedString = "";
    if ( abbreviation == 'h' || abbreviation == 'H' || abbreviation == 'hours' || abbreviation == 'hrs' ) {
      // display as hours
      var hours = (quantity / 60).toFixed(2);
      formattedString = hours + " Hours";
    }
    if ( abbreviation == 'hm' || abbreviation == 'HM' || abbreviation == 'hoursminutes' || abbreviation == 'hrsmins' ) {
      // display as hours and minutes
      var hours = Math.floor(quantity / 60);
      var minutes = quantity % 60;

      formattedString = "";
      if ( hours > 0 ) {
        if ( hours == 1 ) {
          formattedString += hours + " Hour ";
        } else {
          formattedString += hours + " Hours ";
        }
      }
      if ( minutes > 0 ) {
        formattedString += minutes + " Minutes";
      }
    }
    if ( abbreviation == 'm' || abbreviation == 'M' || abbreviation == 'minutes' || abbreviation == 'mins' ) {
      formattedString = quantity += " Minutes";
    }

    return formattedString;
  }

  /* Stringify Address Helper */

  root.stringifyAddress = function(address) {
    if ( !address ) {
      return "";
    }
    var strAddress = "";
    if ( address.num ) {
      strAddress += address.num + ", ";
    }

    if ( address.streetNum ) {
      strAddress += address.streetNum + " ";
    }

    if ( address.streetName ) {
      strAddress += address.streetName + " "
    }

    if ( address.suburb ) {
      strAddress += address.suburb + ", ";
    }

    if ( address.state ) {
      strAddress += address.state + ", ";
    }

    if ( address.postCode ) {
      strAddress += address.postCode + ", ";
    }

    if ( address.country ) {
      strAddress += address.country;
    }

    return strAddress;
  }

  root.stringifyAddressHtml = function(address) {
    if ( !address ) {
      return "";
    }
    var strAddress = "";
    if ( address.num ) {
      strAddress += address.num + ", ";
    }

    if ( address.streetNum ) {
      strAddress += address.streetNum + " ";
    }

    if ( address.streetName ) {
      strAddress += address.streetName + "<br/>"
    }

    if ( address.suburb ) {
      strAddress += address.suburb + ", ";
    }

    if ( address.state ) {
      strAddress += address.state + "<br/>";
    }

    if ( address.postCode ) {
      strAddress += address.postCode + ", ";
    }

    if ( address.country ) {
      strAddress += address.country;
    }

    return strAddress;
  }

  return root;
});



// WEBPACK FOOTER //
// ./src/factories/formatHelper.js